import styled, { css } from "styled-components";
export const GridOneBaseBox = styled.section `
	display: grid;
	grid-template-areas: "a a .";
	overflow-x: scroll;
	flex-wrap: nowrap;
	grid-auto-flow: row dense;

	${(props) => {
    const gap = props.gridGap || 12;
    if (typeof props.gridWidth === "number") {
        return css `
				grid-gap: ${gap}px;
				grid-template-columns: repeat(auto-fill, ${props.gridWidth}px);
			`;
    }
    return css `
			grid-gap: ${gap}px;
			width: ${props.gridWidth};
		`;
}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;

		& > * {
			${(props) => {
    return css `
					margin-right: ${props.gridGap}px || "12px";
				`;
}}
		}
	}
`;
export const SingleScrollContainer = styled(GridOneBaseBox) ``;
export const NormalContainer = styled.section `
	position: relative;
	overflow: hidden;
	margin: 0 auto;
	width: ${(props) => {
    return `${props.gridWidth}px`;
}};

	.leftArrow,
	.rightArrow {
		position: absolute;
		width: 38px;
		height: 88px;
		background: #000000;
		opacity: 0.5;
		z-index: 1;
		border-radius: 0px 4px 4px 0px;
		cursor: pointer;

		&:after {
			display: inline-block;
			content: " ";
			height: 17px;
			width: 17px;
			border-color: #fff;
			border-style: solid;
			border-width: 2px 2px 0 0;
			position: absolute;
			top: 50%;
			margin-top: -6px;
			-webkit-transition: 0.3s;
			transition: 0.3s;
		}

		&:hover {
			transition: 0.3s;
			opacity: 0.8;
		}
	}

	.leftArrow {
		left: 0px;
		&:after {
			left: 13px;
			transform: rotate(-135deg);
		}
	}

	.rightArrow {
		right: 0px;
		border-radius: 4px 0px 0px 4px;
		&:after {
			right: 13px;
			transform: rotate(45deg);
		}
	}
`;
